(() => {
    const DESKTOP = "(min-width: 1025px)";

    function canAnimate() {
        return window.matchMedia(DESKTOP).matches
            && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function cloneChild(node) {
        const clone = node.cloneNode(true);
        clone.classList.add("is-clone");
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll("a, button, input, select, textarea").forEach((el) => {
            el.setAttribute("tabindex", "-1");
        });
        clone.querySelectorAll("img").forEach((img) => {
            img.loading = "lazy";
            img.removeAttribute("fetchpriority");
        });
        return clone;
    }

    function syncTrack(track) {
        track.querySelectorAll(".is-clone").forEach((node) => node.remove());
        if (!canAnimate()) {
            return;
        }
        const originals = [...track.children].filter((node) => !node.classList.contains("is-clone"));
        if (originals.length < 2) {
            return;
        }
        originals.forEach((node) => track.appendChild(cloneChild(node)));
    }

    function boot() {
        const tracks = document.querySelectorAll("[data-site-marquee-track]");
        tracks.forEach((track) => syncTrack(track));
    }

    window.addEventListener("resize", () => {
        window.clearTimeout(boot.resizeTimer);
        boot.resizeTimer = window.setTimeout(() => {
            document.querySelectorAll("[data-site-marquee-track]").forEach((track) => syncTrack(track));
        }, 180);
    });

    window.siteReady(boot);
})();
